<template>
  <v-container fluid fill-height class="dashboard-layout">
    <v-navigation-drawer
      fixed
      mobile-break-point="700"
      v-model="drawer"
      app
      class="main-nav"
      width="240"
    >
      <v-layout class="menu-container" fill-height>
        <v-flex class="main-menus">
          <div class="profile-pic">
            <img :src="require('@/assets/logo_100x100.png')" />
          </div>
          <ul class="menu-items">
            <li
              v-for="menu in menus"
              :key="menu.id"
              class="menu-item"
              v-tippy="{
                placement: 'right',
                arrow: true,
                arrowTransform: 'scale(0.75)',
                theme: 'lgrm-tippy'
              }"
              :title="menu.label"
            >
              <router-link
                :to="{
                  name: menu.id,
                  query: $route.query,
                  params: menu.params
                }"
              >
                <component :is="menu.icon"></component>
              </router-link>
            </li>
          </ul>
          <!-- <div
            class="help-button"
            v-tippy="{
              placement: 'right',
              arrow: true,
              arrowTransform: 'scale(0.75)',
              theme: 'lgrm-tippy'
            }"
            title="Help"
            @click="logout"
          >
            <IconHelp />
          </div> -->
        </v-flex>
        <v-flex class="sub-menus">
          <ul class="menu-items">
            <li
              class="menu-item "
              v-for="subMenu in subMenus"
              :key="subMenu.id"
            >
              <router-link :to="{ name: subMenu.id, query: $route.query }">{{
                subMenu.label
              }}</router-link>
            </li>
          </ul>
          
        </v-flex>
      </v-layout>
    </v-navigation-drawer>

    <v-container fluid fill-height class="pa-0">
      <v-toolbar-side-icon
        class="menu-btn white--text"
        @click.stop="drawer = !drawer"
      ></v-toolbar-side-icon>
      <transition name="fade" mode="out-in">
        <router-view v-if="!loggingOut" class="content" />
      </transition>
    </v-container>

    <v-navigation-drawer
      right
      temporary
      v-model="right"
      fixed
    ></v-navigation-drawer>
    <GlobalNotifications></GlobalNotifications>
  </v-container>
</template>

<script>
import GlobalNotifications from '@/components/GlobalNotifications'
import IconAccount from './img/main_menus/account.svg?inline'

import routes from '../../route_names'

export default {
  name: 'DashboardLayout',
  components: {
    IconAccount,
    GlobalNotifications
  },
  data: function() {
    return {
      drawer: true,
      drawerRight: false,
      right: null,
      left: null,
      loggingOut: false,
      routes: routes,
      menus: [
        {
          label: 'Users',
          id: routes.USERS, // also route name
          icon: IconAccount,
          
          children: [
            {
              label: 'Campaigns',
              id: routes.CAMPAIGNS,
              
            }
          ]
        }
      ]
  }
  },
  mounted: function() {},
  computed: {
    subMenus: function() {
      const vm = this
      if (vm.$route.matched.length > 2)
        return this.menus.find(f => f.id === vm.$route.matched[2].name).children
      else return []
    }
  },
  methods: {
    logout: function() {
      const vm = this
      this.loggingOut = true
      return this.$store
        .dispatch('user/logout')
        .then(function(res) {
          vm.$router.push({
            name: routes.LOGIN,
            params: { lang: vm.$i18n.locale }
          })
        })
        .catch(function() {
          vm.$router.push({
            name: routes.LOGIN,
            params: { lang: vm.$i18n.locale }
          })
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.dashboard-layout {
    padding: 0;
    .main-nav {
        border 0
    }
    .menu-btn.v-btn {
        position fixed
        top: 0
        background: #fff;
        .v-btn__content {
            i {
                color: $color-primary-light-5
            }
        }
    }
    .theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
        background-color #F1F2F6;
    }
    .content {
        padding-top 50px
    }
}
.menu-container {
    ul.menu-items {
        list-style none
        padding 0
    }
    li.menu-item {
        cursor pointer
    }
    .main-menus {
        background-color var(--v-primary-base)
        max-width 50px
        min-width 50px
        position relative
        border: 0
        .profile-pic {
            width 35px
            height 35px
            border-radius 50%
            margin auto
            margin-top 15px
            img {
                width 100%
            }
        }
        .menu-items {
            margin-top 80px
            text-align center
            .menu-item {
                margin-bottom 30px
                svg {
                    width 25px

                    path, polygon, circle, rect {
                        fill: #fff
                    }
                    .transparent {
                        fill: $color-primary
                    }
                }
            }
            .router-link-active {
                svg {
                    path, polygon, circle, rect {
                        fill: var(--v-accent-base)
                    }
                    .transparent {
                        fill: $color-primary
                    }
                }
            }
        }

        .help-button {
            position absolute
            bottom 0
            cursor pointer
            width: 100%
            text-align center
            svg {
                width 25px
            }

            path {
                fill: #fff
            }

            &:hover {
                path {
                    fill: #fff
                }
            }
        }
    }

    .sub-menus {
        background #F6F9FB
        padding: 20px
        padding-top 125px
        position: relative
        .menu-item {
            font-size 16px
            margin-bottom 20px

            a {
                text-decoration none
                color: var(--v-primary-base)
                padding-bottom 3px
                border-bottom 2px solid inherit

                &.router-link-active, &:hover {
                    font-weight bold
                    border-bottom 2px solid var(--v-accent-base)
                }
            }

        }
        .logout-link {
          position absolute
          bottom 10px
          cursor pointer
          width calc(100% - 40px)
          text-align left
        }
    }

}

.list-enter-active, .list-leave-active {
    transition: all .5s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
{
    opacity: 0;
    transform: translateY(30px);
}


</style>
